import styled from "styled-components";

export const BlogNewsComponentMainDiv = styled.main``;

export const BlogNewsComponentNewsDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .blognews-contaner {
    max-width: 752px;
    width: 100%;
    flex: 1;
    flex-flow: column;
    gap: 40px;
    display: flex;
  }
  .blognews-header-container {
    display: flex;
    flex-flow: column;
    gap: 40px;
    width: 100%;
    flex: 1;
  }
  .blognews-text-header-container {
    display: flex;
    width: 100%;
    flex: 1;
    gap: 16px;
    justify-content: space-between;
  }
  .blognews-title-header-container {
    display: flex;
    flex-flow: column;
    gap: 24px;
    width: 100%;
    flex: 1;
  }
  .blognews-title-text-container {
    > h1 {
      font-size: 60px;
      line-height: 1.2em;
    }
    > p {
      font-size: 17px;
    }
  }
  .blognews-contrast-title-text-container {
    > p {
      font-size: 16px;
      font-weight: 500;
      color: rgb(218, 78, 36);
    }
  }
  .blognews-back-container {
    display: flex;
    gap: 16px;
    align-items: center;
  }
  .blognews-back-icon-wrapper {
    display: flex;
    width: 20px;
    height: 20px;
    gap: 4px;
    overflow: hidden;
  }
  .blognews-back-wrapper {
    display: flex;
    gap: 8px;
    &:hover {
      .blognews-back-icon-container {
        color: red;

        > svg {
          transform: translateX(-28px);
          color: red;
        }
      }
    }
  }
  .blognews-back-icon-container {
    color: red;
    > svg {
      transition: all 0.4s;

      width: 20px;
      height: 20px;
      fill: white;
    }
  }
  .blognews-image-container {
    height: 423px;
    width: 100%;
    border-radius: 16px;
    border: 1px solid red;

    > img {
      border-radius: 16px;
    }
  }
  .blognews-news-container {
    display: flex;
    flex-flow: column;
    gap: 20px;
    p {
      line-height: 1.7em;
      font-size: 17px;
      font-weight: 400;
    }
    h3 {
      margin-top: 20px;
      font-size: 44px;
      font-weight: 500;
    }
    ul {
      display: flex;
      gap: 20px;
      flex-flow: column;
    }
    li {
      font-size: 17px;
      font-weight: 400;
    }
  }
  .blognews-news-share-container {
    border: 1px solid #191919;
    display: flex;

    align-items: center;
    gap: 24px;
    justify-content: space-between;
    border-radius: 12px;
    padding: 16px;
    background: #060606;
  }
  .blognews-share-icon-container {
    display: flex;

    align-items: center;
    gap: 24px;
  }
  .blognews-share-icon {
    > svg {
      width: 24px;
      height: 24px;
      color: white;
      fill: white;
    }
  }
  .blognews-news-body {
    display: flex;
    flex-flow: column;
    gap: 40px;
    width:100%;
    flex:1;
  }
`;
